var fallbackCopy = function (value, container) {
    var textarea = document.createElement("textarea");
    textarea.value = value;
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";
    textarea.style.top = "0";
    textarea.style.opacity = "0";
    container.appendChild(textarea);
    textarea.focus();
    textarea.select();
    textarea.setSelectionRange(0, value.length);
    try {
        document.execCommand("copy");
    }
    finally {
        container.removeChild(textarea);
    }
};
export var copyToClipboard = function (value, container) {
    var _a;
    if (!value)
        return;
    if (window.isSecureContext && ((_a = navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText)) {
        navigator.clipboard
            .writeText(value)
            .catch(function () { return fallbackCopy(value, container); });
        return;
    }
    fallbackCopy(value, container);
};
